export const PRIVACY_URL = "https://www.foundersfirstsystem.com/scorecard-privacy-policy";

export const TERMS_URL = "https://www.foundersfirstsystem.com/terms";
export const APPSTORE_URL = "https://apps.apple.com/us/app/five-factors-scorecard/id1521678845";
export const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=com.foundersfirstscorecard";
